export enum ShippingMethods {
    BidderShipping = 'ship_by_bidder',
    HouseShipping = 'ship_by_house',
    LiveShipping = 'la_ship',
    Pickup = 'pickup',
    Unset = '',
}
